import React from "react";
import styled from "styled-components";
import UtilityInfoCard from "./UtilityInfoCard";
import ContactsCard from "src/modules/Contacts/ContactsCard";
import MaterialsDonutCard from "src/components/MaterialsDonutCard";
import { IndividualSystem } from "src/services";
import { Contact } from "src/types/Contact";
import "./utility-details-info.css";

interface UtilityDetailsInfoProps {
  systemDetailResponse: IndividualSystem;
  contacts: Contact[];
  galvanizedAssets: number;
  leadAssets: number;
  nonLeadAssets: number;
  unknownAssets: number;
}

const UtilityDetailsInfo: React.FC<UtilityDetailsInfoProps> = ({
  systemDetailResponse,
  contacts,
  galvanizedAssets,
  leadAssets,
  nonLeadAssets,
  unknownAssets,
}) => {
  return (
    <>
      <div style={{ width: "30%", height: "100%" }}>
        <UtilityInfoCard
          pwsId={systemDetailResponse.data.pwsId}
          counties={systemDetailResponse.data.counties.map((c) => c.shortName)}
          state={systemDetailResponse.data.state}
          pwsType={systemDetailResponse.data.pwsType}
          owner={systemDetailResponse.data.pwsOwner}
          population={systemDetailResponse.data.populationServed}
          serviceLines={systemDetailResponse.data.serviceLineConnections}
        />
      </div>
      <div style={{ width: "30%", height: "100%" }}>
        <StyledContactsCard style={{ height: "100%" }} contacts={contacts} />
      </div>
      <div style={{ width: "40%", height: "100%" }}>
        <MaterialsDonutCard
          galvanized={galvanizedAssets}
          lead={leadAssets}
          nonLead={nonLeadAssets}
          unknown={unknownAssets}
        />
      </div>
    </>
  );
};

export default UtilityDetailsInfo;

const StyledContactsCard = styled(ContactsCard)`
  &&& {
    .carousel.carousel-slider {
      overflow: visible;
    }
  }
`;
